import { useState } from 'react';
import CastingManage from './CastingManage';
import PlaceManage from './PlaceManage';
import ReviewManage from './ReviewManage';
import UpgradeManage from './UpgradeManage';
import './RetreatManage.scss';

type RetreatTab = 'place' | 'placeAdv' | 'casting' | 'review' | 'upgrade';

export default function RetreatManage() {
  const [tab, setTab] = useState<RetreatTab>('place');

  return (
    <div>
      <div className="retreat-admin__tabs">
        <button
          type="button"
          className={`retreat-admin__tab${tab === 'place' ? ' is-active' : ''}`}
          onClick={() => setTab('place')}
        >
          수련회 장소
        </button>
        <button
          type="button"
          className={`retreat-admin__tab retreat-admin__tab--sub${tab === 'placeAdv' ? ' is-active' : ''}`}
          onClick={() => setTab('placeAdv')}
        >
          상위노출관리
        </button>
        <button
          type="button"
          className={`retreat-admin__tab${tab === 'casting' ? ' is-active' : ''}`}
          onClick={() => setTab('casting')}
        >
          수련회 강사
        </button>
        <button
          type="button"
          className={`retreat-admin__tab${tab === 'review' ? ' is-active' : ''}`}
          onClick={() => setTab('review')}
        >
          장소후기
        </button>
        <button
          type="button"
          className={`retreat-admin__tab${tab === 'upgrade' ? ' is-active' : ''}`}
          onClick={() => setTab('upgrade')}
        >
          등업신청
        </button>
      </div>

      {tab === 'casting' && <CastingManage />}
      {(tab === 'place' || tab === 'placeAdv') && <PlaceManage advOnly={tab === 'placeAdv'} />}
      {tab === 'review' && <ReviewManage />}
      {tab === 'upgrade' && <UpgradeManage />}
    </div>
  );
}
